import { getInitialStateFromConfig } from "helpers/form";
import React from "react";
import { apply } from "sources/books/routeTemplates";
import { FormTemplate } from "./templates";

const config = {
    bidId: {},
    name: {
        label: "Название",
        inputProps: { name: "name" },
    },
};
const initialState = getInitialStateFromConfig(config);

class ExcessMileageModal extends FormTemplate {
    sendRequest = (stateData) => {
        return apply(stateData);
    };

    renderBodyInner = () => {
        const { name } = this.props.config;
        return this.renderField(name);
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Сохранить" />;
    };
}

const ConfiguredModal = (props) => (
    <ExcessMileageModal {...props} config={config} initialState={{ ...initialState, bidId: props.bidId }} />
);

export default ConfiguredModal;
